import { Button } from 'antd';
import InfoModal from 'components/InfoModal';
import { I18nt } from 'utils';
import { ModalContent } from 'utils/interfaces';
import { useHistorialCitas } from '../HistorialCitasContext';
import styles from './HistorialCitas.module.less';

export function FormResponseModal() {
	const { statusMessage, resetState } = useHistorialCitas();

	const modalContent: ModalContent = {
		'hc-1': {
			title: 'numero_de_afiliado_no_encontrado',
			body: 'el_numero_que_ingresaste',
		},
		'hc-2': {
			title: 'numero_afiliado_inactivo',
			body: 'para_poder_consultar',
		},
	};

	if (!statusMessage) {
		return null;
	}
	const message = modalContent[statusMessage];
	if (!message) {
		return null;
	}

	return (
		<InfoModal
			onOk={typeof message.action === 'function' ? message.action : resetState}
			okText={message.buttonText}
			body={message.body}
			title={message.title}
			dynamicText={message.dynamicText}
			visible={Boolean(statusMessage)}
		/>
	);
}

export function CancelarCitaModal() {
	const { dispatch, idCita, onCancelarCita } = useHistorialCitas();
	const footer = (
		<footer className={styles.cancelarModalFooter}>
			<div>{I18nt('estas_seguro_que_deseas_cancelar')}</div>
			<div className={styles.cancelarModalButtons}>
				<Button
					onClick={() => dispatch({ type: 'setIdCita' })}
					className='mr-8'
				>
					{I18nt('no')}
				</Button>
				<Button onClick={onCancelarCita} type='primary'>
					{I18nt('si')}
				</Button>
			</div>
		</footer>
	);

	return (
		<InfoModal
			visible={Boolean(idCita)}
			title='cancelar_cita'
			footer={footer}
		/>
	);
}

export function ConfirmacionCancelacionModal() {
	const { showCitaCanceladaModal, dispatch } = useHistorialCitas();
	return (
		<InfoModal
			visible={showCitaCanceladaModal}
			title='su_cita_fue_cancelada_con_exito'
			onOk={() => dispatch({ type: 'showCitaCanceladaModal', payload: false })}
		/>
	);
}
